<template>
  <v-container class="cmpbk black--text" id="reg-container">
    <!--      
   13 Souls Run APP v0.8.1
    Copyright (c) 2024 Blue Cover Six LLC / John Molt
    BCS grants Unlimited License to 13 Souls LLC and Jeff Von Molt -->
    <h2 class="white--text">Register</h2>
    <template>
      <!-- V-stepper start -->
      <v-stepper v-model="stepcount" non-linear vertical class="py-2">
        <v-stepper-step :complete="stepcount > 1" step="1">
          Your Information
          <small>Please Fill out Form</small>
        </v-stepper-step>

        <v-stepper-content step="1" class="ml-4 my-0 mr-2 pa-0">
          <v-card
            color="whitesmoke"
            class="mb-4 pa-2 participate"
            height="auto"
          >
            <span class="label-text">Are you participating Virtually?</span>
            <v-radio-group v-model="form.virt">
              <v-radio label="Yes" value="'virt_yes'"></v-radio>
              <v-radio label="No" value="'virt_no'"> </v-radio>
            </v-radio-group>

            <!-- <v-checkbox v-model="form.virt" label="Yes"></v-checkbox> -->
          </v-card>

          <v-card color="whitesmoke" class="hear mb-4 pa-2" height="auto">
            <v-row>
              <v-col cols="12">
                <v-select
                  attach
                  auto
                  v-model="form.hear"
                  :items="hear_items"
                  label="How did you hear about our event?"
                  class="custom-label-color"
                >
                </v-select>
              </v-col>
            </v-row>
          </v-card>

          <v-card color="whitesmoke" class="position mb-4 pa-2" height="auto">
            <span class="label-text"
              >For volunteers; do you have a preferred position? (We cannot
              guarantee position, but will try to accommodate).</span
            >
            <v-radio-group v-model="form.position">
              <v-radio label="Parking" value="'position_parking'"></v-radio>
              <v-radio
                label="Registration/Check-in"
                value="'position_regcheck'"
              >
              </v-radio>
              <v-radio label="Course Set-up" value="'position_setup'">
              </v-radio>
              <v-radio
                label="Boothing Set-up/Tear-down"
                value="position_boothset"
              >
              </v-radio>
              <v-radio
                label="Starting/Finish Line"
                value="position_startfinish"
              >
              </v-radio>
              <v-radio label="Ceremony" value="'position_ceremony'"> </v-radio>
              <v-radio
                label="On-course Assistance"
                value="position_courseassist"
              >
              </v-radio>
              <v-radio label="Merch Booth" value="merch_booth"></v-radio>

              <v-radio label="Open to wherever placed" value="position_open">
              </v-radio>
            </v-radio-group>
          </v-card>
          <v-btn color="primary" @click="update(2)"> Continue </v-btn>

          <v-btn text @click="cancel"> Cancel </v-btn>
        </v-stepper-content>

        <!-- v-stepper 2 -->
        <v-stepper-step :complete="stepcount > 2" step="2">
          Contact Information
        </v-stepper-step>

        <v-stepper-content step="2" class="ml-4 my-0 mr-2 pa-0">
          <v-card color="whitesmoke" class="contact mb-4 pa-2" height="auto">
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    required
                    maxlength="120"
                    label="name*"
                    class="custom-label-color"
                    color="red"
                    v-model="form.name"
                    :rules="nameRules"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    required
                    :rules="reqRules"
                    maxlength="500"
                    label="Address (street address, city, state, zip)*"
                    class="custom-label-color"
                    color="red"
                    v-model="form.address"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="">
                  <v-text-field
                    required
                    :rules="emailRules"
                    maxlength="120"
                    placeholder="myname@a_domain.com"
                    label="Email*"
                    class="custom-label-color"
                    color="red"
                    v-model="form.email"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    required
                    v-mask="'###-###-####'"
                    maxlength="15"
                    placeholder="123-123-1234"
                    label="Phone Number*"
                    class="custom-label-color"
                    color="red"
                    v-model="form.phone"
                    :rules="phoneRules"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card>

          <v-btn color="primary" @click="update(3)"> Continue </v-btn>
          <v-btn color="primary" class="ml-2" @click="stepcount = 1">
            Go Back
          </v-btn>
          <v-btn text @click="cancel"> Cancel </v-btn>
        </v-stepper-content>

        <!-- v-stepper 3 -->

        <v-stepper-step :complete="stepcount > 3" step="3">
          Run Info
        </v-stepper-step>

        <v-stepper-content step="3" class="ml-4 my-0 mr-2 pa-0">
          <v-card color="whitesmoke" class="run mb-12 ps-2" height="auto">
            <v-row>
              <v-col cols="12">
                <v-select
                  attach
                  auto
                  :items="partvol"
                  v-model="form.partvol"
                  label="Are you a participant or a volunteer?*"
                  class="custom-label-color"
                  color="red"
                  required
                >
                </v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  attach
                  auto
                  :items="distance"
                  v-model="form.distance"
                  label="Distance you are running"
                  class=""
                  required
                >
                </v-select>
              </v-col>
              <v-col cols="12" class="">
                <v-select
                  attach
                  auto
                  :items="mode"
                  v-model="form.mode"
                  label="Mode"
                  class=""
                >
                </v-select>
              </v-col>
            </v-row>
          </v-card>

          <v-btn color="primary" @click="update(4)"> Continue </v-btn>
          <v-btn color="primary" class="ml-2" @click="stepcount = 2">
            Go Back
          </v-btn>
          <v-btn text @click="cancel"> Cancel </v-btn>
        </v-stepper-content>

        <!-- V-stepper 4 -->
        <v-stepper-step :complete="stepcount > 4" step="4">
          Merchandise
        </v-stepper-step>

        <v-stepper-content step="4" class="ml-4 my-0 mr-2 pa-0">
          <v-card
            color="whitesmoke"
            class="mb-4 pa-2 participate"
            height="auto"
          >
            <span class="label-text"
              >Do you intend on purchasing a t-shirt, sweatshirt or hat at the
              event day of?</span
            >
            <v-radio-group v-model="form.merch">
              <v-radio label="Yes" value="'merch_yes'"></v-radio>
              <v-radio label="No" value="'merch_no'"> </v-radio>
              <v-radio label="Maybe" value="'merch_maybe'"> </v-radio>
            </v-radio-group>
          </v-card>
          <v-card color="whitesmoke" class="run mb-12 ps-2" height="auto">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  maxlength="60"
                  placeholder="Count 2, XXXX"
                  label="T-shirt-Quantity and size"
                  class=""
                  v-model="form.tshirt"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  maxlength="60"
                  label="Sweatshirt: Quantity and Size"
                  placeholder="Count 2, Medium"
                  class=""
                  v-model="form.sweat"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" class="">
                <v-text-field
                  maxlength="60"
                  label="Women's v-neck: Quantity and Sizes"
                  placeholder="Count 2, Medium"
                  class=""
                  v-model="form.razor"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" class="">
                <v-text-field
                  maxlength="60"
                  label="Hat: Quantity and Sizes"
                  placeholder="Count 2, Large"
                  class=""
                  v-model="form.hat"
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-card>
          <div class="d-flex flex-column justify-center">
            <v-container fluid>
              <h4>
                To Continue you must agree to the waiver below (then scoll
                down):
              </h4>
              <a
                @click="window.scrollTo(0, document.body.scrollHeight)"
                href="/13_SOULS_RUN_RELEASE_AND_WAIVER_OF_LIABILITY_AGREEMENT_2026.pdf"
                target="_blank"
                >Read Wavier Here</a
              >
              <v-checkbox
                v-model="show_finish"
                :label="'I have read, understood, and agree to the 13 SOULS RUN RELEASE AND WAIVER OF LIABILITY.'"
              ></v-checkbox>
            </v-container>
            <div v-if="show_finish">
              <h3>To finish your registration Select a Donation (PayPal)</h3>
              <h4 class="mt-3">Minimum Donation $20</h4>
              <v-btn color="primary" @click="checkout()" class="mb-2">
                Donate now with Paypal: $20
              </v-btn>
              <!-- <h4 class="mt-3">
                Bundle Donation includes a shirt and a medal: $60
              </h4>
              <v-btn color="primary" @click="checkout2()" class="mb-2">
                Donate now with Paypal: $60
              </v-btn> -->
              <h4 class="mt-3">
                I would like to set my own Donation Value to help these
                families...
              </h4>
              <v-btn color="primary" @click="checkout3()" class="mb-2">
                Set your own value (min $20)
              </v-btn>
              <h4 class="mt-3">I will be a volunteer.</h4>
              <v-btn color="primary" @click="volunteer" class="mb-2">
                Volunteer Submission
              </v-btn>
              <div class="mt-3">
                <v-btn color="primary" class="ml-2" @click="stepcount = 3">
                  Go Back
                </v-btn>
                <v-btn text class="mb-2" @click="cancel"> Cancel </v-btn>
              </div>
            </div>
          </div>
        </v-stepper-content>
      </v-stepper>
    </template>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */
@media (min-width: 0px) {
  #reg-container {
    max-width: 768px;
  }
  .bkclr {
    background-color: rgb(0, 25, 48);
    padding: 8px;
  }
  .participate .label-text {
    font-size: 16px;
    opacity: 0.8;
  }

  .custom-label-color .v-label {
    color: red;
    opacity: 1;
  }
}

/* 768 media q */
@media (min-width: 768px) {
}

/* ipad lansdscape */
@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}
</style>

<!-- data: () => ({
      items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
    }), -->

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import Checkout from "./checkout.vue";
export default {
  name: "register",
  mixins: [bus_common],
  data() {
    return {
      show_finish: false,
      valid: true,
      stepcount: 1,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      reqRules: [
        (v) => !!v || "Name is required",
        (v) =>
          (v && v.length <= 120) || "Name must be less than 120 characters",
      ],
      nameRules: [
        (v) => !!v || "Name is required",
        (v) =>
          (v && v.length <= 120) || "Name must be less than 120 characters",
      ],
      phoneRules: [
        (v) => !!v || "Phone is required",
        (v) =>
          /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/.test(v) ||
          "Phone must be valid",
      ],
      //^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$
      form: {
        regstId: 0,
        virt: "",
        hear: "",
        position: "",
        name: "",
        address: "",
        email: "",
        phone: "",
        merch: "",
        tshirt: "",
        sweat: "",
        razor: "",
        hat: "",
        partvol: "",
        distance: "",
        mode: "",
        amount: 0.0,
      },
      hear_items: [
        "Street signs",
        "The Acorn",
        "Past participant",
        "Family/friend",
        "Flyer",
      ],
      registration: {},
      partvol: ["Participant", "Volunteer"],
      distance: ["1K", "5K", "10K", "Half Marathon"],
      mode: ["Run", "Walk", "Bike", "Scooter", "Skate", "Other"],
    };
  },
  computed: {
    rndnumx: function () {
      //this.mrbreakpoint("rnum");
      return Math.floor(Math.random() * (10000 - 1)) + 1; // Y
    },
  },
  watch: {
    rndnum() {
      return this.rndnumx;
    },
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },

    cancel() {
      this.$router.push("/");
    },
    get_record() {
      let regstId = this.$store.state.regstId;

      var formIn = {};
      formIn.regstId = regstId;
      formIn.apiname = "get_record";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.stepcount = 1;
          this.form = this.mno(data);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    volunteer() {
      var formIn = {};
      formIn.fields = this.form;
      formIn.fields.s_del = "f";
      formIn.apiname = "update_record";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.form = this.mno(data);
          this.$router.push("/");
          this.swall_it(
            "Registration Status",
            "Complete.",
            "success",
            null,
            null
          );
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    checkout() {
      var formIn = {};
      formIn.fields = this.form;
      formIn.apiname = "update_record";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.form = this.mno(data);
          this.$router.push("/checkout");
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    checkout2() {
      var formIn = {};
      formIn.fields = this.form;
      formIn.apiname = "update_record";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.form = this.mno(data);
          this.$router.push("/checkout2");
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    checkout3() {
      var formIn = {};
      formIn.fields = this.form;
      formIn.apiname = "update_record";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.form = this.mno(data);
          this.$router.push("/checkout3");
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    update(count) {
      if (count == 3) {
        let valness = this.$refs.form.validate();
        if (!valness) {
          this.swall_it(
            "Form Entry Status",
            "Please address the red fields before continuing.",
            "error",
            null,
            null
          );
          return true;
        }
      }
      this.stepcount = count;

      var formIn = {};
      formIn.fields = this.form;
      formIn.apiname = "update_record";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          console.log("update_record");
          this.form = this.mno(data);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    create_min_record() {
      var formIn = {};
      // formIn.email = this.$store.state.user.email;
      // formIn.token = this.$store.state.user.token;
      formIn.fields = this.form;

      formIn.apiname = "create_min_record";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          console.log("min record");
          this.form = this.mno(data);
          this.$store.commit("setRegstId", this.form.regstId);
          this.swall_it(
            "Registration Status",
            "Starting new registration",
            "success",
            null,
            null
          );
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },

    init() {
      this.show_loader(false);
      // this.mrbreakpoint("init");
      if (this.$store.state.regstId == -1) {
        this.create_min_record();
      } else {
        this.get_record();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
